




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPlace } from '@resclick/data-access';

@Component
export default class QPhoneNumberInput extends Vue {
  @Prop() defaultCountry!: string;
  @Prop({ default: () => ({ countryCode: '', areaCode: '', number: '' }) }) value!: {
    countryCode: string;
    areaCode: string;
    number: string;
  };

  countries: IPlace[] = [];
  filteredCountries: IPlace[] = [];
  country = '';

  get countryCode() {
    return this.value.countryCode;
  }

  set countryCode(value: string) {
    this.$emit('input', Object.assign({}, this.value, { countryCode: value }));
  }

  get areaCode() {
    return this.value.areaCode;
  }

  set areaCode(value: string) {
    this.$emit('input', Object.assign({}, this.value, { areaCode: String(value) }));
  }

  get phoneNumber() {
    return this.value.number;
  }

  set phoneNumber(value: string) {
    this.$emit('input', Object.assign({}, this.value, { number: String(value) }));
  }

  get selectedCountry() {
    return this.countryCodeOptions.find((country) => country.iso === this.country) || {};
  }

  get countryCodeOptions() {
    return this.filteredCountries.map((country) => {
      return {
        label: country.phoneCode,
        value: country.phoneCode,
        iso: country.countryCode,
        countryCode: country.phoneCode,
        icon: country.countryCode.toLowerCase() + '.svg',
      };
    });
  }

  setAreaCode(value: string) {
    this.areaCode = value.replace(/\(/, '').replace(/\)/, '');
  }

  filterFn(val: any, update: any, abort: any) {
    update(
      () => {
        const needle = val.toLowerCase();
        this.filteredCountries = this.countries.filter((v) => v.phoneCode.toLowerCase().indexOf(needle) > -1);
      },
      (ref: any) => {
        if (val !== '' && ref.options.length > 0 && ref.optionIndex === -1) {
          ref.moveOptionSelection(1, true); // focus the first selectable option and do not update the input-value
          ref.toggleOption(ref.options[ref.optionIndex], true); // toggle the focused option
        }
      },
    );
  }

  created() {
    this.phoneNumber = this.value.number;
    this.countryCode = this.value.countryCode;
    this.areaCode = this.value.areaCode;

    this.$getCrsList('geo', 'countries', {}).then((data) => {
      this.countries = data;
      this.filteredCountries = data;
      this.country = this.defaultCountry;

      if (this.country) {
        const { phoneCode } = this.countries.find((country) => country.countryCode === this.defaultCountry) || {};
        this.countryCode = phoneCode || '';
      }
    });
  }
}
